// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.registration-form-container__error {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.registration-form-container.public-page__content-container-content {
    background: transparent;
    padding: 0;
    border-radius: 0;
    align-items: stretch;
    height: 100%;
}

@media screen and (min-width: 680px) {
    .registration-form-container.public-page__content-container-content {
        height: 100vh;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/TenantRegistration/Register.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,UAAU;IACV,gBAAgB;IAChB,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ","sourcesContent":[".registration-form-container__error {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.registration-form-container.public-page__content-container-content {\n    background: transparent;\n    padding: 0;\n    border-radius: 0;\n    align-items: stretch;\n    height: 100%;\n}\n\n@media screen and (min-width: 680px) {\n    .registration-form-container.public-page__content-container-content {\n        height: 100vh;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
